import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  ApiErrorCodes,
  parseApiResponseError,
} from '../../../../api/api-error';
import apiManager from '../../../../api/api-manager';
import {
  AggiornaEmailError,
  AggiornaEmailErrorCodiciErroreEnum,
  TimeoutOTP,
} from '../../../../api/generated/apc/api';
import { getAPIRequestHeaders } from '../../../../utils/api-utils';
import { getVerificationEmailOrPhoneNumberError } from '../../../../utils/error-utils';
import { AsyncThunkConfig } from '../../../async-thunk-config';
import {
  ChangeEmailState,
  InsertEmailChangeEmailError,
  VerificationEmailChangeEmailError,
} from './change-email-type';
import { verifyInsertEmailChangeEmailFields } from './change-email-utils';

export const insertEmailChangeEmail = createAsyncThunk<
  TimeoutOTP,
  void,
  AsyncThunkConfig<InsertEmailChangeEmailError>
>('insert_email_change_email', async (_, thunkApi) => {
  try {
    const userState = thunkApi.getState().data.user;
    const state = thunkApi.getState().features.changeEmail;

    const validationError = verifyInsertEmailChangeEmailFields(state);
    if (validationError) {
      return thunkApi.rejectWithValue(validationError);
    }

    const response = await apiManager.changeContactApi.cambioEmail(
      userState.username,
      {
        email: state.email,
      },
      getAPIRequestHeaders(thunkApi)
    );
    return response.data;
  } catch (error) {
    console.error(error);
    const apiError = parseApiResponseError<AggiornaEmailError>(error);
    const errorCodes = apiError.payload?.codiciErrore;

    if (apiError.responseErrorCode === ApiErrorCodes.BAD_REQUEST) {
      if (errorCodes?.length > 0) {
        switch (errorCodes[0]) {
          case AggiornaEmailErrorCodiciErroreEnum.EmailNonUtilizzabile:
            return thunkApi.rejectWithValue('EMAIL_NON_UTILIZZABILE');
        }
      }
    }
    return thunkApi.rejectWithValue('GENERIC_ERROR');
  }
});

export const verificationEmailChangeEmail = createAsyncThunk<
  void,
  void,
  AsyncThunkConfig<VerificationEmailChangeEmailError>
>('verification_email_change_email', async (_, thunkApi) => {
  try {
    const userState = thunkApi.getState().data.user;
    const state: ChangeEmailState = thunkApi.getState().features.changeEmail;

    await apiManager.changeContactApi.verificaCambioEmail(
      userState.username,
      {
        email: state.email,
        codiceDiVerificaEmail: state.changeEmailVerificationCodeEmail,
        codiceDiVerificaCellulare: state.changeEmailVerificationCodePhoneNumber,
      },
      getAPIRequestHeaders(thunkApi)
    );
    return null;
  } catch (error) {
    return thunkApi.rejectWithValue(
      getVerificationEmailOrPhoneNumberError(error)
    );
  }
});
